function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
var transitionStyles = {
  entering: {
    opacity: 0,
    transform: 'translateY(20px)',
    height: 0
  },
  entered: {
    opacity: 1,
    transform: 'translateY(0px)'
  },
  exiting: {
    opacity: 0,
    transform: 'translateY(-20px)'
  },
  exited: {
    opacity: 0,
    transform: 'translateY(20px)'
  }
};

var FadeUp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FadeUp, _Component);

  function FadeUp() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FadeUp.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$delay = _this$props.delay,
        delay = _this$props$delay === void 0 ? 0 : _this$props$delay,
        _this$props$duration = _this$props.duration,
        duration = _this$props$duration === void 0 ? 300 : _this$props$duration,
        inProp = _this$props["in"],
        _this$props$appear = _this$props.appear,
        appear = _this$props$appear === void 0 ? true : _this$props$appear,
        _this$props$ease = _this$props.ease,
        ease = _this$props$ease === void 0 ? 'linear' : _this$props$ease,
        disableAnimation = _this$props.disableAnimation;

    if (disableAnimation) {
      return inProp && /*#__PURE__*/React.createElement("div", null, children);
    }

    return /*#__PURE__*/React.createElement(Transition, {
      "in": !!inProp,
      unmountOnExit: true,
      timeout: duration + delay,
      appear: appear
    }, function (state) {
      return /*#__PURE__*/React.createElement("div", {
        style: _objectSpread({
          transition: "opacity " + duration + "ms " + delay + "ms, transform " + duration + "ms " + delay + "ms",
          transitionTimingFunction: ease
        }, transitionStyles[state])
      }, children);
    });
  };

  return FadeUp;
}(Component);

export { FadeUp as default };